import createScriptLoader from './createScriptLoader';
import { NavigationOptions } from './typing';

const global = window.top ?? window;
export namespace ByteappSDK {
  const src = `https://lf1-cdn-tos.bytegoofy.com/goofy/developer/jssdk/jssdk-1.0.3.js`;
  let loadedPromise: Promise<void> | null;

  export function init() {
    if (loadedPromise) {
      return loadedPromise.catch(() => {
        return (loadedPromise = createScriptLoader(src));
      });
    }
    return (loadedPromise = createScriptLoader(src));
  }
  export function loaded(): Promise<void> {
    if (!loadedPromise) {
      return init();
    }
    return loadedPromise.then(() => {
      if (!global.tt) {
        throw new Error('加载异常');
      }
    });
  }

  export function redirectTo(url: string): Promise<void> {
    return loaded().then(() => {
      return new Promise<void>((resolve, reject) => {
        window.tt.miniProgram.redirectTo({
          url: url,
          success: () => {
            resolve();
          },
          fail: () => {
            reject();
          },
        });
      });
    });
  }
  export function navigateTo(url: string): Promise<void> {
    return loaded().then(() => {
      return new Promise<void>((resolve, reject) => {
        window.tt.miniProgram.navigateTo({
          url: url,
          success: () => {
            resolve();
          },
          fail: () => {
            reject();
          },
        });
      });
    });
  }
  export function navigateBack() {
    return loaded().then(() => {
      return new Promise<void>((resolve, reject) => {
        window.tt.miniProgram.navigateBack({
          success: () => {
            resolve();
          },
          fail: () => {
            reject();
          },
        });
      });
    });
  }
  export function postMessage(message: any): Promise<void> {
    return loaded().then(() => {
      return new Promise<void>(() => {
        window.tt.miniProgram.postMessage({
          data: message,
        });
      });
    });
  }
}

export function navigateToByteapp(
  target: string,
  { replace }: NavigationOptions = {},
) {
  Promise.resolve().then(() => {
    if (replace) {
      return ByteappSDK.redirectTo(target);
    } else {
      return ByteappSDK.navigateTo(target);
    }
  });
  return Promise.resolve();
}
